<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editform" ref="editformRef" label-width="82px">
        <el-form-item label="保修卡号" class="addAdminForm">
          <el-input type="textarea" v-model="editform.sn" placeholder="请输入保修卡号"></el-input>
        </el-form-item>
        <el-form-item label="客户名称" class="addAdminForm">
          <el-input type="textarea" v-model="editform.kehuname" placeholder="请输入客户名称"></el-input>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input type="textarea" v-model="editform.beizhu" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickback">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editform: {
        orderid: '',
        sn: '',
        kehuname: '',
        beizhu: ''
      }
    }
  },
  methods: {
    LoadData (parentdata) {
      console.log(parentdata)
      this.editform.orderid = parentdata.Orderid
      this.editform.sn = parentdata.Sn
      this.editform.kehuname = parentdata.Kehuname
      this.editform.beizhu = parentdata.Beizhu
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditNaoxjStockSaleSn()
    },
    apiEditNaoxjStockSaleSn: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.editform.orderid,
        sn: that.editform.sn,
        kehuname: that.editform.kehuname,
        beizhu: that.editform.beizhu
      }
      console.log(data)
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditNaoxjStockSaleSn, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
          }
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}

.speed {
    width: 440px;
    margin-right: 15px;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(255, 0, 0);
}
</style>
